import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NotFoundPage from "./NotFoundPage";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import CreatePasswordForm from "../components/forms/CreatePasswordForm";
import { isValidToken } from "../actions/authActions";

// TODO: check if token is valid, otherwise redirect to homepage

class CreatePasswordPage extends Component {
  componentDidMount() {
    this.props.isValidToken(this.props.match.params.token);
  }

  render() {
    return this.props.tokenIsValid ? (
      <CenteredPageContentContainer>
        <PaperContainer title="Wachtwoord aanmaken">
          <CreatePasswordForm token={this.props.match.params.token} />
        </PaperContainer>
      </CenteredPageContentContainer>
    ) : (
      <NotFoundPage />
    );
  }
}

CreatePasswordPage.propTypes = {
  isValidToken: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }),
  }),
  tokenIsValid: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  tokenIsValid: state.auth.isValidToken.isValid,
  isFetching: state.auth.isValidToken.isFetching,
});

export default connect(mapStateToProps, { isValidToken })(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/pages/CreatePasswordPage.js